const vimeoPattern = /(?:http?s?:\/\/)?(?:www\.)?(?:player\.)?(?:vimeo\.com\/)(?:(?:channels\/[A-z]+\/)|(?:groups\/[A-z]+\/videos\/)|(?:video\/))?([0-9]+)(?:\/[\S]*)?/i

export default vimeoPattern;